import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const propTypes = {
  kind: PropTypes.string,
  className: PropTypes.string,
};

const defaultProps = {
  kind: 'primary',
};

class Button extends React.Component {
  render() {
    const { kind, className = '' } = this.props;
    return <button {...this.props} className={`btn ${className} ${styles[kind]}`} />;
  }
}

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;



// WEBPACK FOOTER //
// src/components/shared/Button/index.jsx